import { render, staticRenderFns } from "./RirekishoLicenseCard.vue?vue&type=template&id=0fd9c062&scoped=true"
import script from "./RirekishoLicenseCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./RirekishoLicenseCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RirekishoLicenseCard.vue?vue&type=style&index=0&id=0fd9c062&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd9c062",
  null
  
)

export default component.exports